import { isAccessAllowedRules } from './isAccessAllowedRules'
import {
    MEMSOURCE_LINGUIST,
    TEMPO_PROJECT,
    TEMPO_REPORTING,
    TEMPO_REQUEST,
    TEMPO_SETTINGS,
    TEMPO_TERMINOLOGY,
    TEMPO_VALIDATE,
} from '../../config/roles'
import { FilterElement } from '../../interfaces/FilterElement'
import { Column } from '../../interfaces/Column'

const LINGUIST_FILTER_NOT_ALLOW = ['priceMin', 'priceMax']
const LINGUIST_COLUMN_NOT_ALLOW = ['totalPriceFormat']

// Permission list
export const PERMISSION_TEMPO_SHOW_PROJECT_LIST = 'tempo_show_project_list'
export const PERMISSION_TEMPO_CREATE_REQUEST = 'tempo_create_request'
export const PERMISSION_TEMPO_SETTINGS = 'tempo_settings'
export const PERMISSION_TEMPO_SHOW_REPORTING = 'tempo_show_reporting'
export const PERMISSION_TEMPO_TERMINOLOGY = 'tempo_terminology'
export const PERMISSION_TEMPO_VALIDATE = 'tempo_validate'

const accessibilityList = {
    [PERMISSION_TEMPO_SHOW_PROJECT_LIST]: [TEMPO_PROJECT],
    [PERMISSION_TEMPO_CREATE_REQUEST]: [TEMPO_REQUEST],
    [PERMISSION_TEMPO_SETTINGS]: [TEMPO_SETTINGS],
    [PERMISSION_TEMPO_SHOW_REPORTING]: [TEMPO_REPORTING],
    [PERMISSION_TEMPO_TERMINOLOGY]: [TEMPO_TERMINOLOGY],
    [PERMISSION_TEMPO_VALIDATE]: [TEMPO_VALIDATE],
}

export const isAccessible = (permission: string) => isAccessAllowedRules(accessibilityList[permission])

// Actions
export const filterAccordingToRoles = (filtersList: FilterElement[]): FilterElement[] => {
    if (isAccessAllowedRules([MEMSOURCE_LINGUIST])) {
        return filtersList.filter((filter) => !LINGUIST_FILTER_NOT_ALLOW.includes(filter.name))
    }

    return filtersList
}

export const columnAccordingToRoles = (columnList: Column[]): Column[] => {
    if (isAccessAllowedRules([MEMSOURCE_LINGUIST])) {
        return columnList.filter((column) => !LINGUIST_COLUMN_NOT_ALLOW.includes(column.id))
    }
    return columnList
}
